<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="row input">
          <q-input
            data-cy="usuarioProveedor"
            outlined
            v-model="usuarioProveedorData"
            label="Usuario/email"
            class="col-md-12"
            @input="edited()"
          >
          </q-input>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row input password">
          <q-input
            outlined
            v-model="claveProveedorData"
            type="password"
            label="Contraseña"
            class="col-md-12"
            @input="edited()"
          >
          </q-input>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row input">
          <q-input
            outlined
            v-model="codigoINEProvincia"
            label="Código INE Provincia"
            class="col-md-12"
            type="number"
            :rules="[ val => (val.length === 2 || val.length === 0) || 'El código debe tener 2 carácteres']"
            @input="edited()"
          >
          </q-input>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row input">
          <q-input
            outlined
            v-model="codigoINEMunicipio"
            label="Código INE Municipio"
            class="col-md-12"
            type="number"
            :rules="[ val => (val.length === 3 || val.length === 0)|| 'El código debe tener 3 carácteres']"
            @input="edited()"
          >
          </q-input>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    proveedor: Object
  },
  data () {
    return {
      usuarioProveedorData: '',
      claveProveedorData: '',
      codigoINEProvincia: '',
      codigoINEMunicipio: ''
    };
  },
  watch: {
    proveedor () {
      this.usuarioProveedorData = this.proveedor.usuarioProveedor ? this.proveedor.usuarioProveedor : null;
      this.claveProveedorData = this.proveedor.claveProveedor ? this.proveedor.claveProveedor : null;
      this.codigoINEProvincia = this.proveedor.codigoINEProvincia ? this.proveedor.codigoINEProvincia : '';
      this.codigoINEMunicipio = this.proveedor.codigoINEMunicipio ? this.proveedor.codigoINEMunicipio : '';
    }

  },
  methods: {
    edited () {
      let proveedor = {
        usuarioProveedor: this.usuarioProveedorData ? this.usuarioProveedorData : '',
        claveProveedor: this.claveProveedorData ? this.claveProveedorData : '',
        codigoINEProvincia: this.codigoINEProvincia ? this.codigoINEProvincia : '',
        codigoINEMunicipio: this.codigoINEMunicipio ? this.codigoINEMunicipio : ''
      };
      this.$emit('dataUserProveedor', proveedor);
    }
  }
};
</script>
<style lang="scss" scoped>
  .input {
    margin-top: 27px;
  }
  .col-md-6{
    padding-left: 5px;
    padding-right: 5px;
  }
</style>
